// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddProd_importCsvCard__Z96ai","addProductBtnContainer":"AddProd_addProductBtnContainer__k848-"};